import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import scheme from '../../static/js/scheme';
import {imgCrop} from '../../static/js/imgcrop';
import vm from '../../static/js/unit';
import List from '../list';
import Base from '../../base';
import './index.scss';

const Level = ({params}) => {

  // 接口返回内容
  const [level, setLevel] = useState({});

  useEffect(() => {
    setLevel({});
    vm.ajax({
      url: process.env.REACT_APP_CHENGDU + 'getSeriesListByLevelIds',
      data: {
        showid: process.env.REACT_APP_CHEZHAN_ID,
        levelids: Base.levels[parseInt(params.type)].ids,
      },
      success(res) {
        setLevel(res.result);
      }
    });
  }, [params.type]);
  const handleClick = (name) => {
    Base.tongji('carclick', {
      position: Base.levels[parseInt(params.type)].name,
      name: name,
    });
  }

  return (
    <List tab={params.type}>
      {
        level.length > 0 && <section className="findcar-index-series">
          <ul>
          {
            level.map(ser => {
              return <li className="athm-series__item" key={ser.seriesid}>
                <a onClick={() => handleClick(ser.seriesname)} href={scheme.insidebrowser(`${process.env.REACT_APP_LINK}home/${ser.brandid}-${ser.seriesid}?source=series`)}>
                  <LazyLoad once offset={100}>
                    <img src={imgCrop(ser.serieslogo, '200x0__')} alt={ser.seriesname} />
                  </LazyLoad>
                  <div>
                    <strong>{ser.seriesname}</strong>
                    <span>{ser.tip}</span>
                    <p>{`${ser.brandname}/${ser.fctname}/${ser.levelname}`}</p>
                  </div>
                </a>
              </li>
            })
          }
          </ul>
        </section>
      }
    </List>
  )
}

export default Level;